import { Component, Input } from '@angular/core';

/**
 * Generated class for the PercentBadgeComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'percent-badge',
  templateUrl: 'percent-badge.html'
})
export class PercentBadgeComponent {

  @Input('percent') percent: number | string;
  isString: boolean;
  constructor() {

  }

  ngOnInit(){
    // debugger;
    if(typeof(this.percent) == 'string'){
      this.isString = true;
    }else{
      this.isString = false;
    }
  }

  getClass(): string{
    if(this.isString){
      const percent = <string>this.percent;
      if(percent.indexOf('-') == -1){
        return 'val-positive';
      }else{
        return 'val-negative';
      }
    }else{
      const percent = <number>this.percent;
      if(percent >= 0){
        return 'val-positive';
      }else{
        return 'val-negative';
      }
    }
  }



}



// WEBPACK FOOTER //
// ./src/components/percent-badge/percent-badge.ts